import Image from 'next/image';

const InvolitDark: React.FC = (props) => {
  return (
    <Image
      src="/bottom/102.png"  // 注意这里路径不需要加 images
      alt="ss"
      width={67}
      height={64}
    />
  );
};

export default InvolitDark;